import {Item} from '../../item/Item';
import { Word } from '../../word/Word'

 export class Dictionary extends Item {
    // public type: string;
    private words: Array<Word> = [];
    private relatedWords: Array<Word> = [];
    constructor(collection:any){
        super(collection);
        // this.type = collection.type;
    }
    setWords(words : Word){
        this.words
    }
    setRelatedWords(words: Word[]){
        this.relatedWords = words;
    }
    getSummary(){
        return this.title;
    }
}